import { LayoutContext } from 'contexts/LayoutContext'
import { useScrollPosition } from 'hooks/useScrollPosition'
import { AcceptenceTerm } from 'modules/AcceptenceTerm'
import GenericMessageWarning, { DefaultNode } from 'modules/GenericMessageWarning'
import { ReactNode, useContext, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useLocation } from 'react-router-dom'
import { useGlobalStore } from 'store/useGlobalStore'
import shallow from 'zustand/shallow'

import { Button, Col, Row } from 'react-bootstrap'
import { ISystemSetting } from 'types/baseTypes'
import { Footer } from './Footer'
import { HeaderParent } from './Header'
import { StyledBody, StyledLayout } from './Layout.styled'

interface IProps {
  title?: string
  children: ReactNode
}

export const Layout = ({ title, children }: IProps) => {
  const [userClaims, isAuthenticated, errorMessages, getSystemSettings] = useGlobalStore(
    (state) => [state.userClaims, state.isAuthenticated, state.errorMessages, state.getSystemSetting],
    shallow
  )
  const { setIsSticky } = useContext(LayoutContext)

  const isShowFooter = useMemo(
    () => ((userClaims.IsTermAccepted && userClaims.Username) || !userClaims.Username ? true : false),
    [userClaims.IsTermAccepted, userClaims.Username]
  )

  const url = getSystemSettings('AUCTION_ACCESS_URL') as ISystemSetting
  const [isOpen, setIsOpen] = useState(true)
  const renderErrorMessage = (key: string, value: string): ReactNode => {
    switch (key) {
      case 'ShowGenericMessage':
        return <DefaultNode />
      case 'ShowAuctionACCESSMessage':
        return (
          <>
            <Row>
              <Col>
                <p>{value}</p>
              </Col>
            </Row>
            <Row>
              <Col className="mb-4">
                <Link className="navigation-link" onClick={() => window.open(url.ValueString, '_blank')} to="#">
                  Click here
                </Link>{' '}
                to register and enable your access
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <input type="checkbox" />
                <label className="pl-2">Don’t show this again</label>
              </Col>
              <Col sm={7} className="text-right">
                <Button size="lg" onClick={() => setIsOpen(false)}>
                  Continue to Site
                </Button>
              </Col>
            </Row>
          </>
        )
      default:
        return <></>
    }
  }
  const location = useLocation()

  useScrollPosition(
    ({ currPos }) => {
      const headerHeight = document.querySelector<HTMLElement>('.main-nav')?.offsetHeight
      if (currPos.y <= -headerHeight) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    },
    [location.pathname]
  )

  return (
    <StyledLayout>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeaderParent />
      <StyledBody>{isAuthenticated && !userClaims.IsTermAccepted ? <AcceptenceTerm /> : children}</StyledBody>
      {isShowFooter && <Footer />}
      {errorMessages &&
        Object.entries(errorMessages).map(([key, value]) => (
          <GenericMessageWarning show={isOpen}>{renderErrorMessage(key, value)}</GenericMessageWarning>
        ))}
    </StyledLayout>
  )
}
